import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "transition duration-100 ease-in-out"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }, " KOKKU ", -1)
const _hoisted_3 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_4 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_5 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_6 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700 border-r" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicReportsListItem = _resolveComponent("ClinicReportsListItem")!
  const _component_BaseTableBodyWrapper = _resolveComponent("BaseTableBodyWrapper")!

  return (_openBlock(), _createBlock(_component_BaseTableBodyWrapper, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workerUIDs, (workerUID) => {
        return (_openBlock(), _createBlock(_component_ClinicReportsListItem, {
          key: workerUID,
          workerUID: workerUID,
          "snap-shots": _ctx.workerSnapshots[workerUID],
          isDetailView: _ctx.isDetailView,
          onOnWorker: _ctx.onWorker,
          onOnPicturesCounts: e => _ctx.onPicturesCounts({counts: e, workerUID})
        }, null, 8, ["workerUID", "snap-shots", "isDetailView", "onOnWorker", "onOnPicturesCounts"]))
      }), 128)),
      (_ctx.isDetailView)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.totals['Intraoraalne'] ?? 0), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.totals['OPTG'] ?? 0), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.totals['3D sektorist'] ?? 0), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.totals['3D lõualuust'] ?? 0), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.totals['3D lõualuudest'] ?? 0), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.totals['CEPH'] ?? 0), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.totals.total), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}